import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { SystemEntry } from '@store/system/system.store';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SystemService extends BaseService {
    constructor() {
        super();
        this.setApiName('System/config');
    }

    override mapArrayResponseToObject<T>(response: { [id: string]: SystemEntry }): T {
        // Remove the id named "$id" added by the backend
        response && delete response['$id'];
        return Object.values(response) as SystemEntry[] as any;
    }
}
